(ns ballot-scout-v2-frontend.layout.sidebar.views.election-switcher
  (:require
   [ballot-scout-v2-frontend.components.click-outside :refer [click-outside]]
   [ballot-scout-v2-frontend.components.icon :refer [icon] :as icon]
   [ballot-scout-v2-frontend.components.link :refer [link]]
   [ballot-scout-v2-frontend.subs :as subs]
   [re-frame.core :as rf]
   [reagent.core :as r]))

(defn jurisdiction-election-link [election]
  (let [current-election @(rf/subscribe [::subs/current-election])]
    [link
     {:route-name :ballot-scout-v2-frontend.routes/jurisdiction-home
      :params {:partner-slug @(rf/subscribe [::subs/current-partner-slug])
               :jurisdiction-slug @(rf/subscribe [::subs/current-jurisdiction-slug])
               :election-slug (:election/slug election)}}
     (if (= (:election/id current-election) (:election/id election))
       [:tr.navbar-item.selected
        [:td [icon ::icon/check {:class "is-hidden-mobile"}]]
        [:td (:election/name election)]]
       [:tr.navbar-item [:td] [:td (:election/name election)]])]))

(defn partner-election-link [election]
  (let [current-election @(rf/subscribe [::subs/current-election])]
    [link
     {:route-name :ballot-scout-v2-frontend.routes/partner-home
      :params {:partner-slug @(rf/subscribe [::subs/current-partner-slug])
               :election-slug (:election/slug election)}}
     (if (= (:election/id current-election) (:election/id election))
       [:tr.navbar-item.selected
        [:td [icon ::icon/check {:class "is-hidden-mobile"}]]
        [:td (:election/name election)]]
       [:tr.navbar-item [:td] [:td (:election/name election)]])]))

#_:clj-kondo/ignore
(defn dropdown [on-partner-admin-page current-election elections]
  (let [active? (r/atom false)]
    (fn [on-partner-admin-page current-election elections]
      [click-outside
       {:on-click-outside #(reset! active? false)}
       (fn [ref]
         [:a {:ref ref :on-click #(swap! active? not)}
          [:div.switcher.navbar-item.has-dropdown {:class (when @active? "is-active")}
           [:div.dropdown-text
            [:div.text (:election/name current-election)]
            (if @active? [icon ::icon/chevron-up] [icon ::icon/chevron-down])]
           (when @active?
             [:div.navbar-dropdown
              [:table
               [:<> (for [e (->> elections (filter :election/slug) (sort-by (juxt :election/date :election/name)))]
                      (if on-partner-admin-page
                        [partner-election-link e]
                        [jurisdiction-election-link e]))]]])]])])))

(defn component []
  (let [on-partner-admin-page @(rf/subscribe [::subs/on-partner-admin-page?])
        on-global-stats-page @(rf/subscribe [::subs/on-global-stats-page?])
        current-partner-slug @(rf/subscribe [::subs/current-partner-slug])
        current-jurisdiction-slug @(rf/subscribe [::subs/current-jurisdiction-slug])
        elections (if (or on-partner-admin-page on-global-stats-page)
                    @(rf/subscribe [::subs/elections-for-partner current-partner-slug])
                    @(rf/subscribe [::subs/elections-for-jurisdiction current-jurisdiction-slug]))
        current-election @(rf/subscribe [::subs/current-election])]
    (cond
      (not elections)
      [:small.switcher.dropdown-text [:div.text "Loading elections..."]]

      (= 1 (count elections))
      [:div.switcher.dropdown-text.is-hidden-mobile
       [:div.text (-> elections first :election/name)]]

      :else
      [dropdown on-partner-admin-page current-election elections])))
